import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <g id="xls" transform="translate(-565 -298)">
        <g id="file-extension" transform="translate(565 298)">
          <path
            id="Контур_725"
            data-name="Контур 725"
            d="M20.7,0H32.387l6.192,6.168V20.625A1.375,1.375,0,0,1,37.2,22H20.7a1.375,1.375,0,0,1-1.375-1.375V1.375A1.375,1.375,0,0,1,20.7,0Z"
            transform="translate(-19.329)"
            fill="#2a8d57"
          />
          <path
            id="Контур_726"
            data-name="Контур 726"
            d="M209.125,6.367h-4.793a1.375,1.375,0,0,1-1.375-1.375V.193Z"
            transform="translate(-189.894 -0.179)"
            fill="#186035"
          />
          <path
            id="Контур_817"
            data-name="Контур 817"
            d="M-3.731-2.977-3.1-4.271h1.072L-3.111-2.34-1.993-.378H-3.076L-3.731-1.7-4.387-.378h-1.08L-4.352-2.34l-1.086-1.93h1.07ZM-.7-1.1H.938v.722H-1.634V-4.271H-.7ZM3.4-1.412a.386.386,0,0,0-.146-.321,1.811,1.811,0,0,0-.512-.238,4.912,4.912,0,0,1-.6-.238,1.134,1.134,0,0,1-.757-1.021A.916.916,0,0,1,1.572-3.8a1.219,1.219,0,0,1,.533-.385,2.076,2.076,0,0,1,.775-.138,1.816,1.816,0,0,1,.753.15,1.192,1.192,0,0,1,.517.426,1.114,1.114,0,0,1,.184.632H3.4a.471.471,0,0,0-.146-.369.568.568,0,0,0-.394-.131.641.641,0,0,0-.4.111.34.34,0,0,0-.146.282.343.343,0,0,0,.16.271,2.023,2.023,0,0,0,.564.251A3.456,3.456,0,0,1,3.7-2.42a1.114,1.114,0,0,1,.631,1,.951.951,0,0,1-.385.8,1.713,1.713,0,0,1-1.056.291,2.1,2.1,0,0,1-.857-.17A1.292,1.292,0,0,1,1.46-.959a1.212,1.212,0,0,1-.194-.68h.941a.6.6,0,0,0,.162.461.765.765,0,0,0,.525.148.6.6,0,0,0,.368-.1A.331.331,0,0,0,3.4-1.412Z"
            transform="translate(10.625 15)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};

export default memo(Icon);
